export const breakpoints = {
  sm: '640px', // Phones
  md: '768px', // Tablets
  lg: '1024px', // Laptops
  xl: '1280px', // Desktops
  '2xl': '1536px', // Large desktops
};

export type BreakpointKey = keyof typeof breakpoints;
